import { ProgressStepper } from "components/ShipmentProgressSteps/progressStepper";

const POST_BOOKING_STEPS = ["BOOKED", "PICKED UP", "DELIVERED"];

interface Props {
  shipment: PublicShipment;
}

export function PublicShipmentProgress(props: Props) {
  const { shipment } = props;

  const getActiveStep = () => {
    if (shipment.shipment_status === "DELIVERED") {
      return 2;
    }
    if (shipment.shipment_status === "PICKED_UP") {
      return 1;
    }
    return 0;
  };

  return (
    <ProgressStepper
      allSteps={POST_BOOKING_STEPS}
      progressValue={getActiveStep()}
      shipmentStatus={shipment.shipment_status}
    />
  );
}
